import React 				from 'react';
import ReactDOM 		from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

export default class DragDropUpload extends BLComponent 
{
	constructor (props) 
	{
		super(props);

		this.state = 	{
							menuOpen: false,
							isUploading: false
						};
	}

	componentDidUpdate() 
	{
	}

	render() 
	{
		const {classes = '', type = 'full', size = 'normal', accept='image/*', prompt, icon} = this.props;

		const isUploading = this.props.uploadError ? false : this.state.isUploading;

		if (type == 'full') 
		{
			return (
				<article ref={this.props.dragDropRef ? this.props.dragDropRef : ''} className={"drag-drop-upload drag-drop-upload--" + size + ' ' + classes}>
					<label className="drag-drop-upload__internal" onDrop={(e) => this.dropEvent(e)} onDragOver={(e) => this.dragOverEvent(e)}>
						<input className="drag-drop-upload__file-input" accept={accept} onChange={(e) => this.onSelectedFiles(e.target.files)} type="file" disabled={isUploading}/>
						<div className="drag-drop-upload__cta">
							<div className="drag-drop-upload__cta-top">
								{icon ? icon : null}
								<h2 className="drag-drop-upload__prompt">{prompt ? prompt : "Drag files here to upload"}</h2>
								<div className="text-divider l-margin-y--sm">
									<div className="text-divider__text">Or</div>
								</div>
							</div>
							<label className={"btn btn--cta drag-drop-upload__btn"}>
								<input type="file" accept={accept} className="l-hide" onChange={(e) => this.onSelectedFiles(e.target.files)} disabled={isUploading}/>{isUploading ? "Uploading" : "Browse files"}
							</label>
						</div>
						{this.props.children ? <div className="drag-drop-upload__content">{this.props.children}</div> : null}
					</label>
				</article>
			);
		}
		else if ( type == 'simple' )
		{
			return (
				<article ref={this.props.dragDropRef ? this.props.dragDropRef : ''} className={"drag-drop-upload drag-drop-upload--simple drag-drop-upload--" + size + ' ' + classes}>
					<label className="drag-drop-upload__internal" onDrop={(e) => this.dropEvent(e)} onDragOver={(e) => this.dragOverEvent(e)}>
						<input className="drag-drop-upload__file-input" accept={accept} type="file" onChange={(e) => this.onSelectedFiles(e.target.files)}/>
					</label>
					{this.props.children ? <div className="drag-drop-upload__content--simple">{this.props.children}</div> : null}
				</article>
			);
		}
	}

	dropEvent(e) 
	{
		e.preventDefault();
		if(this.state.isUploading)
			return;
			
		this.setState({isUploading: true});

		if ( e.dataTransfer.items ) 
		{
			const files = [];
			// Use DataTransferItemList interface to access the file(s)
			for ( var i = 0; i < e.dataTransfer.items.length; ++i ) 
			{
				// If dropped items aren't files, reject them
				if(e.dataTransfer.items[i].kind === 'file') 
				{
					var file = e.dataTransfer.items[i].getAsFile();
					files.push(file);
				}
			}
			this.props.onDropFiles(files, this.uploadFinished);
		} 
		else 
		{
			this.props.onDropFiles(e.dataTransfer.files, this.uploadFinished);
			// Use DataTransfer interface to access the file(s)
		} 
		
		// Pass event to removeDragData for cleanup
		this.removeDragData(e)
	}

	onSelectedFiles(files)
	{
		this.setState({isUploading: true});
		this.props.onDropFiles(files, this.uploadFinished);
	}

	dragOverEvent(e) 
	{
		e.preventDefault();
	}

	removeDragData(e) 
	{
		if (e.dataTransfer.items) 
			e.dataTransfer.items.clear();
		else
			e.dataTransfer.clearData();
	}

	uploadFinished = () =>
	{
		this.setState({isUploading: false})
	}
};